module.exports = {
  USER_LOCAL_STORAGE_KEY: "user",
  SETTING_STORAGE_KEY: "setting",
  DEFAULT_FALLBACK_LANGUAGE: "th",
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  ROLE_ADMIN: "ADMIN",
  ROLE_HR: "HR",
  ROLE_EMPLOYEE: "EMPLOYEE",
  ROLE_MANAGER: "MANAGER",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  NORMAL_OPEN: "NORMAL_OPEN",
  TEMPORARILY_CLOSED: "TEMPORARILY_CLOSED",
  PERMANENTLY_CLOSED: "PERMANENTLY_CLOSED"
};
